// Chụp ảnh (dữ liệu mẫu theo board Mint-Mov-Phone2 khung "Chụp ảnh"). Chỉ giả lập trong bộ nhớ.

export type PhotoMode = 'epod' | 'eir' | 'rf' | 'pti';
export type Sim = 'ok' | 'blur' | 'dark' | 'glare' | 'edge' | 'dev';

export const MODES: readonly { key: PhotoMode; label: string }[] = [
  { key: 'epod', label: 'ePOD' },
  { key: 'eir', label: 'EIR' },
  { key: 'rf', label: 'Máy lạnh' },
  { key: 'pti', label: 'PTI xe' },
];

export const NAME: Record<Exclude<PhotoMode, 'pti'>, string> = { epod: 'ePOD', eir: 'EIR', rf: 'Máy lạnh' };

export const NEED: Record<Exclude<PhotoMode, 'pti'>, string> = {
  epod: 'Bước Xong cần: ePOD — biên bản giao nhận có chữ ký + tên người nhận. Thiếu ePOD không kết thúc được chuyến.',
  eir: 'Bước Tại depot / Hạ cont cần: ảnh phiếu EIR rõ số cont, tình trạng vỏ, chữ ký depot.',
  rf: 'Cont lạnh cần: ảnh màn hình máy lạnh lúc nhận, rời kho và hạ cont. AI đọc nhiệt độ và vent, so với yêu cầu −18°C.',
};

export const SIMS: readonly [Sim, string][] = [['ok', 'Đạt'], ['blur', 'Mờ'], ['dark', 'Tối'], ['glare', 'Lóa'], ['edge', 'Thiếu góc']];
export const SIM_RF: [Sim, string] = ['dev', 'Nhiệt lệch'];

export const BAD: Record<'blur' | 'dark' | 'glare' | 'edge', string> = {
  blur: 'Ảnh mờ — tì tay chắc, lau ống kính rồi chụp lại. Ảnh không đạt không gửi được.',
  dark: 'Ảnh quá tối — bật đèn flash hoặc ra chỗ sáng rồi chụp lại.',
  glare: 'Ảnh bị lóa — nghiêng máy tránh đèn chiếu thẳng vào giấy.',
  edge: 'Thiếu góc giấy — lùi máy cho đủ 4 góc nằm trong khung.',
};

export const PTI = ['Lốp và áp suất lốp', 'Đèn, xi-nhan, còi', 'Phanh và hơi phanh', 'Chốt mooc, khoá cont (twist-lock)', 'Giấy tờ xe, phù hiệu, bảo hiểm', 'Dầu máy, nước làm mát'] as const;

export interface Shot { id: string; mode: PhotoMode; k: string; d: string }

export const SEED_SHOTS: Shot[] = [{ id: 's0', mode: 'rf', k: 'Máy lạnh lúc nhận cont', d: '06:38 · −18,2°C · vent đóng · đạt' }];

export const vn = (n: number) => String(n).replace('.', ',').replace('-', '−');

/** Chất lượng ảnh: nét / sáng / đủ 4 góc. */
export function quality(sim: Sim) {
  return { sharp: sim !== 'blur', light: sim !== 'dark' && sim !== 'glare', edge: sim !== 'edge' };
}

/** Kết quả một lần bấm Chụp: ảnh lỗi → thông báo; ảnh đạt → dòng ảnh (+ đọc nhiệt độ cho máy lạnh). */
export function shoot(mode: Exclude<PhotoMode, 'pti'>, sim: Sim, hm: string, id: string):
  { bad: string } | { shot: Shot; rf: { v: number; dev: number } | null } {
  if (sim !== 'ok' && sim !== 'dev') return { bad: BAD[sim] };
  let k = `${NAME[mode]} · ${hm}`;
  let d = 'Đạt · đã cắt, nắn thẳng · đóng dấu · nén 4,1 MB → 0,4 MB';
  let rf: { v: number; dev: number } | null = null;
  if (mode === 'rf') {
    const v = sim === 'dev' ? -13.6 : -18.4;
    const dev = Math.abs(v + 18);
    rf = { v, dev };
    k = 'Máy lạnh lúc rời kho';
    d = `${hm} · ${vn(v)}°C · vent đóng · ${dev > 2 ? `lệch ${vn(Number(dev.toFixed(1)))}°C` : 'đạt'}`;
  }
  if (mode === 'epod') k = 'ePOD · biên bản giao nhận';
  if (mode === 'eir') k = 'EIR lấy rỗng';
  return { shot: { id, mode, k, d }, rf };
}

export function rfText(rf: { v: number; dev: number }): string {
  return rf.dev > 2
    ? `AI đọc ${vn(rf.v)}°C — lệch ${vn(Number(rf.dev.toFixed(1)))}°C so với −18°C. Đã báo điều độ THANH và CS MAI.`
    : `AI đọc ${vn(rf.v)}°C · vent đóng — đạt (cho phép ±2°C)`;
}

export function sendLabel(n: number, sent: boolean, offline: boolean): string {
  return sent ? `Đã gửi · gửi thêm ${n} ảnh` : offline ? `Lưu ${n} ảnh, gửi khi có sóng` : `Gửi ${n} ảnh`;
}
